export default __webpack_public_path__ + "static/bg-k-platform-sharing-41abbea8c07fb1a5d0ea3e8b9c2e7991.webp";